import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: reduce ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.75, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ text, className = "", delay = 0, lineDelay = 0.14, lines = 3 }) {
  const reduce = useReducedMotion();
  const words = (text || "").split(/\s+/).filter(Boolean);
  const per = Math.max(1, Math.ceil(words.length / Math.max(1, lines)));
  const rows = [];
  for (let i = 0; i < words.length; i += per) rows.push(words.slice(i, i + per).join(" "));
  return (
    <span className={className}>
      {rows.map((row, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className="block will-change-transform"
            initial={{ y: reduce ? "0%" : "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.95, delay: delay + i * lineDelay, ease: EASE }}
          >
            {row}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Marquee({ items, className = "" }) {
  const row = (hidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden ? "true" : undefined}>
      {items.map((item, i) => (
        <span key={`${item}-${i}`} className="flex items-center">
          <span className="font-display text-3xl md:text-5xl italic text-outline-gold whitespace-nowrap px-6 md:px-10">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`overflow-hidden ${className}`}>
      <div className="flex w-max animate-marquee">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
